// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_lTa","cls2":"shared-cls2_tVl shared-cls1_lTa"};